<div class="password-dialog">
  <div class="dialog-banner">
    <mat-icon class="banner-icon">lock_reset</mat-icon>
    <div class="banner-text">
      <h2>{{ "COMPONENTS.SET_PASSWORD_FORM.TITLE" | translate }}</h2>
      <span>{{ user.first_name }} {{ user.last_name }} ({{ user.username }})</span>
    </div>
  </div>

  <mat-divider></mat-divider>

  <form
    novalidate
    [formGroup]="setPasswordForm"
    (ngSubmit)="onSubmit()"
  >
    <div class="dialog-content">
      <div class="form-section">
        <div class="section-label">
          <mat-icon class="section-icon">key</mat-icon>
          <span>{{ "COMPONENTS.SET_PASSWORD_FORM.SECTION_NEW_PASSWORD" | translate }}</span>
        </div>

        <mat-form-field class="full-width" appearance="outline">
          <mat-label>{{ "COMPONENTS.ADMINISTRATOR_FORM.PASSWORD.LABEL" | translate }}</mat-label>
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            placeholder="{{ 'COMPONENTS.ADMINISTRATOR_FORM.PASSWORD.PLACEHOLDER' | translate }}"
            formControlName="password"
            required
            autocomplete="new-password"
          />
          <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword" [attr.aria-label]="'COMPONENTS.SET_PASSWORD_FORM.TOGGLE_PASSWORD_VISIBILITY' | translate">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-hint>{{ "COMPONENTS.ADMINISTRATOR_FORM.PASSWORD.HINT" | translate }}</mat-hint>
          <mat-error *ngIf="setPasswordForm.get('password').hasError('required')">
            {{ "COMPONENTS.ADMINISTRATOR_FORM.PASSWORD.ERRORS.REQUIRED" | translate }}
          </mat-error>
          <mat-error *ngIf="setPasswordForm.get('password').hasError('minlength')">
            {{ "COMPONENTS.ADMINISTRATOR_FORM.PASSWORD.ERRORS.MIN_LENGTH" | translate }}
          </mat-error>
        </mat-form-field>

        <div class="strength-indicator" *ngIf="passwordStrengthLabel">
          <div class="strength-bar">
            <div class="strength-segment"
                 *ngFor="let i of [1, 2, 3, 4, 5]"
                 [class.filled]="i <= passwordStrength"
                 [class.weak]="passwordStrength <= 1"
                 [class.fair]="passwordStrength === 2"
                 [class.good]="passwordStrength === 3"
                 [class.strong]="passwordStrength >= 4">
            </div>
          </div>
          <span class="strength-label"
                [class.weak]="passwordStrength <= 1"
                [class.fair]="passwordStrength === 2"
                [class.good]="passwordStrength === 3"
                [class.strong]="passwordStrength >= 4">
            {{ passwordStrengthLabel }}
          </span>
        </div>

        <mat-form-field class="full-width" appearance="outline">
          <mat-label>{{ "COMPONENTS.ADMINISTRATOR_FORM.CONFIRM_PASSWORD.LABEL" | translate }}</mat-label>
          <input
            matInput
            [type]="hideConfirmPassword ? 'password' : 'text'"
            placeholder="{{ 'COMPONENTS.ADMINISTRATOR_FORM.CONFIRM_PASSWORD.PLACEHOLDER' | translate }}"
            formControlName="confirm_password"
            required
            autocomplete="new-password"
          />
          <button mat-icon-button matSuffix type="button" (click)="hideConfirmPassword = !hideConfirmPassword" [attr.aria-label]="'COMPONENTS.SET_PASSWORD_FORM.TOGGLE_CONFIRM_PASSWORD_VISIBILITY' | translate">
            <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-hint>{{ "COMPONENTS.ADMINISTRATOR_FORM.CONFIRM_PASSWORD.HINT" | translate }}</mat-hint>
          <mat-error *ngIf="setPasswordForm.get('confirm_password').hasError('required')">
            {{ "COMPONENTS.ADMINISTRATOR_FORM.CONFIRM_PASSWORD.ERRORS.REQUIRED" | translate }}
          </mat-error>
          <mat-error *ngIf="setPasswordForm.get('confirm_password').hasError('minlength')">
            {{ "COMPONENTS.ADMINISTRATOR_FORM.CONFIRM_PASSWORD.ERRORS.MIN_LENGTH" | translate }}
          </mat-error>
          <mat-error *ngIf="setPasswordForm.get('confirm_password').hasError('mustMatch')">
            {{ "COMPONENTS.ADMINISTRATOR_FORM.CONFIRM_PASSWORD.ERRORS.NO_MATCH" | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="dialog-actions">
      <button mat-stroked-button type="button" (click)="dialogRef.close()">
        {{ "COMMON.CANCEL" | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        type="submit"
        class="submit-btn"
        [disabled]="setPasswordForm.invalid"
      >
        <mat-icon>lock_reset</mat-icon>
        {{ "COMMON.SET_PASSWORD" | translate }}
      </button>
    </div>
  </form>
</div>
